@if (billingAreaWidgetData && initialized) {
    <mvs-widget [widgetData]="billingAreaWidgetData"></mvs-widget>
}
